import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";

const quickLinks = [
  { label: "Products", path: "/products" },
  { label: "About Us", path: "/about" },
  { label: "Blog", path: "/blog" },
  { label: "Contact", path: "/contact" },
];

const categoryLinks = [
  { label: "Injectables", path: "/products?category=Injectables" },
  { label: "Tablets", path: "/products?category=Tablets" },
  { label: "Capsules", path: "/products?category=Capsules" },
  { label: "Infusions", path: "/products?category=Infusions" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/5 bg-[#020617]">
      <div className="max-w-7xl mx-auto px-6 pt-20 pb-28 md:pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6" data-testid="footer-logo">
              <img src="/logo.jpg" alt="Drukst Biotech" className="w-10 h-10 rounded-full object-cover" />
              <div>
                <h3 className="text-lg font-bold text-white">DRUKST</h3>
                <p className="text-[10px] tracking-[0.2em] text-[#94A3B8] uppercase">Biotech Pvt. Ltd.</p>
              </div>
            </Link>
            <p className="text-sm text-[#94A3B8] leading-relaxed mb-6">
              Your Health is Our Concern. Delivering premium pharmaceutical solutions across India.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-bold tracking-[0.15em] text-white/60 uppercase mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map(link => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g,'-')}`}
                    className="text-sm text-[#94A3B8] hover:text-[#2DD4BF] transition-colors duration-300 flex items-center gap-1 group"
                  >
                    {link.label}
                    <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-xs font-bold tracking-[0.15em] text-white/60 uppercase mb-6">Categories</h4>
            <ul className="space-y-3">
              {categoryLinks.map(link => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-category-${link.label.toLowerCase().replace(/\s/g,'-')}`}
                    className="text-sm text-[#94A3B8] hover:text-[#2DD4BF] transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-bold tracking-[0.15em] text-white/60 uppercase mb-6">Get in Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#2DD4BF] mt-0.5 shrink-0" />
                <a href="mailto:info@drukstbiotech.com" data-testid="footer-email" className="text-sm text-[#94A3B8] hover:text-white transition-colors">
                  info@drukstbiotech.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#2DD4BF] mt-0.5 shrink-0" />
                <a href="tel:+919250019785" data-testid="footer-phone" className="text-sm text-[#94A3B8] hover:text-white transition-colors">
                  +91 9250019785
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#2DD4BF] mt-0.5 shrink-0" />
                <p className="text-sm text-[#94A3B8]">
                  Idar Highway Road, Dhandha,<br />Songadh, Himatnagar 383001,<br />Gujarat, India
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#94A3B8]/60">
            &copy; {new Date().getFullYear()} Drukst Biotech Pvt. Ltd. All rights reserved.
          </p>
          <p className="text-xs text-[#94A3B8]/40">
            Your Health is Our Concern
          </p>
        </div>
      </div>
    </footer>
  );
}
